export const FETCH_CTV_REQUEST = 'FETCH_CTV_REQUEST';
export const FETCH_CTV_DATA = 'FETCH_CTV_DATA';
export const FETCH_CTV_ERROR = 'FETCH_CTV_ERROR';
export const RESET_CTV_DATA = 'RESET_CTV_DATA';
